import { Box, Stack } from "@chakra-ui/layout";
import React from "react";
import { Copyright } from "./Copyright";
import { Logo } from "./Logo";
import { SocialMediaLinks } from "./SocialMediaLinks";

export default function Footer() {
  return (
    <Box
      width="100%"
      as="footer"
      role="contentinfo"
      py="8"
      px={{ base: "4", md: "8" }}
      bg="#D03230"
    >
      <Stack spacing={4} maxW="7xl" mx="auto" width="100%">
        <Stack
          direction={{ base: "column", sm: "row" }}
          spacing="4"
          align="center"
          justify="space-between"
        >
          <Logo />
          <SocialMediaLinks />
        </Stack>
        <Copyright alignSelf={{ base: "center", sm: "start" }} />
      </Stack>
    </Box>
  );
}
